import { useEffect, useRef } from "react";
import CategoriesConstraintTab from "../components/constraint/CategoriesConstraintTab";
import CitizensConstraintTab from "../components/constraint/CitizensConstraintTab";
import ConstraintTabBar from "../components/constraint/ConstraintTabBar";
import EmployeeConstraintTab from "../components/constraint/EmployeeConstraintTab";
import MainContentWrapper from "../components/UI/pageStructure/MainContentWrapper";
import { useAppSelector } from "../store/hooks";
import { ConstraintTabBarType } from "../types/constraint";
import useConstraintData from "../hooks/useConstraintData";

const constraintTabContent: Record<ConstraintTabBarType, JSX.Element> = {
  Employee: <EmployeeConstraintTab />,
  Citizens: <CitizensConstraintTab />,
  Categories: <CategoriesConstraintTab />,
};

export default function ConstraintPage() {
  useConstraintData();
  const { selectedConstraintTab } = useAppSelector(
    (state) => state.constraintSlice,
  );
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    scrollRef.current?.scrollTo({ top: 0 });
  }, [selectedConstraintTab]);

  return (
    <section className="flex flex-col relative">
      <div className="flex justify-end min-h-[43px]">
        <ConstraintTabBar />
      </div>

      <MainContentWrapper
        classes="flex flex-col overflow-hidden"
        firstTab="Employee"
        selectedTab={selectedConstraintTab}
      >
        {/* Scroll lives here, not in MainContentWrapper, so tab-change resets are scoped to this page only. */}
        <div ref={scrollRef} className="overflow-y-auto flex-1">
          {constraintTabContent[selectedConstraintTab]}
        </div>
      </MainContentWrapper>
    </section>
  );
}
